import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { BookOpen } from 'lucide-react';
import { API_BASE_URL } from '../../services/api';

const SwaggerDashboard = ({ onClose }) => {
    // Construct URLs from API_BASE_URL
    const baseUrl = API_BASE_URL.replace(/\/api\/v1\/?$/, '');
    const swaggerUrl = baseUrl + '/swagger-ui/index.html';
    const jsonUrl = baseUrl + '/v3/api-docs';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            <Card className="w-full max-w-7xl h-[95vh] flex flex-col shadow-2xl">
                <CardHeader className="flex flex-row items-center justify-between border-b pb-4 py-3">
                    <div className="flex items-center gap-2">
                        <BookOpen className="h-6 w-6 text-purple-600" />
                        <CardTitle className="text-xl">API Documentation</CardTitle>
                        <span className="text-xs text-muted-foreground ml-2 hidden md:inline">({swaggerUrl})</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <Button variant="ghost" size="sm" onClick={onClose}>Close</Button>
                    </div>
                </CardHeader>
                <div className="flex-1 w-full bg-white overflow-hidden rounded-b-xl">
                    <iframe
                        src={swaggerUrl}
                        title="Swagger UI"
                        className="w-full h-full border-0"
                    />
                </div>
            </Card>
        </div>
    );
};

export default SwaggerDashboard;
